import { useCallback } from 'react';
import { useBuildingPackageId } from './use-building-package-id';
import { useFileUpload } from './use-file-upload';
import { useProjectId } from './use-project-id';
import { useAddBuildingPackageFilesMutation } from '../api';
/**
 * Hook to upload a file and add it to a building package
 *
 * @returns an upload function
 */
export const useBuildingPackageFileUpload = () => {
    const projectId = useProjectId();
    const buildingPackageId = useBuildingPackageId();
    const { upload: uploadFile } = useFileUpload();
    const [addBuildingPackageFile] = useAddBuildingPackageFilesMutation();
    const upload = useCallback(async (files, onProgress) => {
        const uploadedFileIds = [];
        for (const file of files) {
            const uploadedFile = await uploadFile(file, projectId, onProgress);
            uploadedFileIds.push(uploadedFile.id);
        }
        const data = { file_ids: uploadedFileIds };
        return await addBuildingPackageFile({ projectId, buildingPackageId, data: data }).unwrap();
    }, [projectId, uploadFile, addBuildingPackageFile, buildingPackageId]);
    return {
        upload,
    };
};
